export default "__VITE_ASSET__DHz4uY4h__"